import {request} from "./request";

export function getTeacherList() {
  return request({
    url: 'teacher/teacherlist'
  })
}

export function TeacherGetClubRank(grade) {
  return request({
    url: 'teacher/TeacherGetClubRank',
    params: {
      grade
    }
  })
}

export function TeacherGetAllClubRank(grade) {
  return request({
    url: 'teacher/TeacherGetAllClubRank',
    params: {
      grade
    }
  })
}

export function TeacherGetClubRankInCourse(cid) {
  return request({
    url: 'teacher/TeacherGetClubRankInCourse',
    params: {
      cid
    }
  })
}

export function TeacherChangePassword(oldPwd, newPwd) {
  return request({
    url: 'teacher/TeacherChangePassword',
    params: {
      oldPwd, newPwd
    }
  })
}

export function getTeacherListLikeName(tecname) {
  return request({
    url: 'teacher/teacherListLikeName',
    params: {
      tecname
    }
  })
}

export function DelTeacherById(id) {
  return request({
    url: 'teacher/delteacherbyid',
    params: {
      id
    }
  })
}

export function DelAllTeacher() {
  return request({
    url: 'teacher/delallteacher',
  })
}

export function AddTeacher(tName, tNum, gender) {
  return request({
    url: 'teacher/AddTeacher',
    params: {
      tName, tNum, gender
    }
  })
}

export function ResetTeacherPassword(id) {
  return request({
    url: 'teacher/ResetTeacherPassword',
    params: {
      id
    }
  })
}
